import { useQuery } from '@tanstack/react-query'
import { getNotificationBadges } from '@web/api/api'
import { notificationBadgesKeys } from './keys'

export function parseNotificationBadgesResponse(data) {
  const payload = data?.data !== undefined ? data.data : data

  if (
    payload == null ||
    typeof payload !== 'object' ||
    Array.isArray(payload)
  ) {
    return 0
  }

  const status = String(payload.status ?? '').toUpperCase()
  if (status !== 'UNREAD') {
    return 0
  }

  const raw = payload.messagesAvailable
  const n = typeof raw === 'number' ? raw : parseInt(String(raw), 10)
  if (Number.isNaN(n) || n < 0) {
    return 0
  }

  return n
}

export const useNotificationBadgesQuery = ({
  patientIds = [],
  useQueryOptions = {}
}) => {
  const sortedIds = [...(patientIds || [])].filter(Boolean).sort()
  const enabled = sortedIds.length > 0

  return useQuery({
    queryKey: notificationBadgesKeys.list(sortedIds),
    queryFn: async () => {
      const res = await getNotificationBadges({ patientIds: sortedIds })
      return parseNotificationBadgesResponse(res)
    },
    enabled,
    staleTime: 15_000,
    ...useQueryOptions
  })
}
